import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-create-success',
  templateUrl: './dialog-create-success.component.html',
  styleUrls: ['./dialog-create-success.component.css']
})
export class DialogCreateSuccessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
